import { addCase } from '@/backend/case'
import type { AddCase, AddCaseParams } from '@/backend/caseTypes'
import { ApiError } from '@/shared/utils/error'
import { useMutation, type UseMutationOptions } from '@tanstack/vue-query'

export const useCreateCase = (
  options: UseMutationOptions<MutationReturn, ApiError, AddCaseParams, unknown> = {},
) => {
  return useMutation({
    mutationFn: async (params: AddCaseParams) => {
      const res = await addCase(params)
      if (!res.ok) {
        throw ApiError.fromFailedResult(res)
      }

      return res.data
    },
    ...options,
  })
}

type MutationReturn = AddCase['successResponse']
